<template>
    <div class="neighborhood-name container">
        <h1 v-if="detail" v-html="detail" class="headline-1"></h1>
    </div>
</template>

<script setup>
    const props = defineProps({
        detail: {
            type: String,
            required: true,
            default: '',
        },
    });

    const { detail } = toRefs(props);
</script>

<style lang="scss" scoped>
    .neighborhood-name {

        h1 {
            margin-bottom: 20px;
        }
    }
</style>
